import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { PublicLayout } from '../../components/layout/PublicLayout';
import { publicPageSeo, useSeo } from '../../hooks/useSeo';
import { ApiSection } from './sections/ApiSection';
import { Features } from './sections/Features';
import { Hero } from './sections/Hero';
import { Pricing } from './sections/Pricing';
import { landingStructuredData } from './structuredData';

export default function LandingPage() {
  useSeo(publicPageSeo('/', { jsonLd: landingStructuredData() }));
  const { hash } = useLocation();

  // React Router does not scroll to `#anchors` on navigation; the nav links use `/#pricing` etc.
  useEffect(() => {
    if (!hash) return;
    document.getElementById(hash.slice(1))?.scrollIntoView({ block: 'start' });
  }, [hash]);

  return (
    <PublicLayout>
      <Hero />
      <Features />
      <Pricing />
      <ApiSection />
    </PublicLayout>
  );
}
